import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

export const SectionHeader = (props) => {
  const Icon = props.icon;
  const { title, onViewAll, viewAllTestId, accent = 'text-primary' } = props;
  return (
    <div className="mb-4 flex items-center justify-between gap-3 sm:mb-6">
      <div className="flex min-w-0 items-center gap-2.5">
        {Icon && <Icon className={`h-5 w-5 shrink-0 ${accent}`} />}
        <h2 className="truncate text-lg font-bold sm:text-2xl">{title}</h2>
      </div>
      {onViewAll && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onViewAll}
          data-testid={viewAllTestId}
          className="shrink-0 text-xs sm:text-sm"
        >
          View All
          <ArrowRight className="ml-1 h-3.5 w-3.5" />
        </Button>
      )}
    </div>
  );
};

export const ScrollRow = ({ children }) => (
  <div className="-mx-4 flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:mx-0 sm:grid sm:snap-none sm:grid-cols-2 sm:gap-5 sm:overflow-visible sm:px-0 sm:pb-0 lg:grid-cols-3 xl:grid-cols-4">
    {React.Children.map(children, (child) => (
      <div className="w-[78%] shrink-0 snap-start sm:w-auto sm:shrink">{child}</div>
    ))}
  </div>
);

export const EmptyState = (props) => {
  const Icon = props.icon;
  const { message } = props;
  return (
    <div className="rounded-2xl border border-border/50 bg-card py-10 text-center sm:py-12">
      {Icon && <Icon className="mx-auto mb-3 h-10 w-10 text-muted-foreground sm:h-12 sm:w-12" />}
      <p className="text-sm text-muted-foreground sm:text-base">{message}</p>
    </div>
  );
};
